document.addEventListener('DOMContentLoaded', () => {
    if (localStorage.getItem('cookieConfirmed') === 'Y')
        return;

    const link = window.policyLink ? window.policyLink : '/';

    const toastWrapper = document.createElement('dialog');
    toastWrapper.className = 'cookie-toast-wrapper';

    const toast = document.createElement('div');
    toast.className = 'cookie-toast';

    const toastBody = document.createElement('div');
    toastBody.className = 'cookie-toast__body';

    const toastText = document.createElement('span');
    toastText.className = 'cookie-toast__text';
    toastText.innerHTML = `Мы используем файлы cookie для хранения данных. Продолжая пользоваться сайтом, вы предоставляете <a href='${link}' target='_blank' class='cookie-toast__link'>согласие на обработку этих файлов.</a>`;

    const toastButton = document.createElement('button');
    toastButton.className = 'cookie-toast__button';
    toastButton.innerText = 'Ок, я согласен';

    toastWrapper.appendChild(toast);
    toast.appendChild(toastBody);
    toastBody.appendChild(toastText);
    toastBody.appendChild(toastButton);

    document.body.appendChild(toastWrapper);

    toastButton.addEventListener('click', () => {
        localStorage.setItem('cookieConfirmed', 'Y');
        document.body.removeChild(toastWrapper);
    });
});
